import React, {Component, PropTypes} from 'react';
import autoBind from 'react-autobind';
import DashboardCharacter from './DashboardCharacter';

export default class DashboardCharacterRow extends Component {
  constructor(props, context) {
    super(props, context);

    autoBind(this);
  }

  render() {
    const {characters, onCharacterClick, selectedDashboardCharacter} = this.props;

    return (
      <div className="dashboard-character-row">
        { characters.map(character => <DashboardCharacter
                                        key={character.get('id')}
                                        characterId={character.get('id')}
                                        characterName={character.get('name')}
                                        characterFoundation={character.get('foundationShort')}
                                        characterImageName={character.get('dashboardImageName')}
                                        selected={selectedDashboardCharacter.get('id') === character.get('id')}
                                        onSelect={onCharacterClick} />) }
      </div>
    );
  }
}

DashboardCharacterRow.propTypes = {
  selectedDashboardCharacter: PropTypes.object,
  characters: PropTypes.array,
  onCharacterClick: PropTypes.func,
};



// WEBPACK FOOTER //
// ./app/features/dashboard/components/DashboardCharacterRow.js